module.exports = __webpack_public_path__ + "static/BPPE_ANNUAL_Institution-30651137e338d97e291ce933abef90ec.pdf";